module.exports = __webpack_public_path__ + "static/media/joanne.d83eaaea.png";